import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import {
  FontSizes,
  LineHeights,
} from '@picsart/design-system/foundation/typography';
import {
  TextColors,
  ErrorColors,
} from '@picsart/design-system/foundation/colors';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  {
    root: {
      width: '100%',
      display: 'flex',
      gap: Spacings.s6,
      flexDirection: 'column',
      [`@media (max-width: ${Breakpoints.xs}px)`]: {
        gap: Spacings.s4,
      },
    },
    label: {
      fontSize: FontSizes.t4,
      lineHeight: LineHeights.t4,
      fontWeight: FontWeights.semibold,
      color: TextColors.base,
      [`@media (max-width: ${Breakpoints.xs}px)`]: {
        fontSize: FontSizes.t3,
        lineHeight: LineHeights.t3,
      },
    },
    error: {
      fontSize: FontSizes.t3,
      color: ErrorColors.base.default,
    },
  },
  { name: 'input-wrapper' }
);

export default useStyles;
